import { useCallback, useEffect, useRef } from 'react';

type Debounce = (fn: () => void) => void;

export const useDebounce = (delay: number): Debounce => {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clearDebounce = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
  }, []);

  const debounce: Debounce = useCallback(
    (fn) => {
      clearDebounce();
      timer.current = setTimeout(() => {
        fn();
      }, delay);
    },
    [clearDebounce, delay]
  );

  useEffect(() => {
    return () => {
      clearDebounce();
    };
  }, [clearDebounce]);

  return debounce;
};
